import  { Resource } from "./Resource";
import { ITrack } from "../AudioManager";
export class TrackResource extends Resource
{
	public get Name(): string {
		return this.name;
	}
	public get Type(): string {
		return "audio"
	}

	public track: ITrack = null;
	public constructor(track: ITrack, name: string, required: boolean = true) {
		super(track.Path, name, required);
		this.track = track;

		this.track.AddLoadedCallback(() => this.Loaded());
		this.track.AddLoadErrorCallback(() => this.LoadError());
	}

	public Load(preventCache: boolean = false): void {
		this.track.Load();
	}

	public override Reload(preventCache: boolean = false): void {
		this.Load(preventCache);
	}
}